import { RouterSuspense } from '@/common/components/RouterSuspense/RouterSuspense';
import { PLAN } from '@/common/constants/markets';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { IMenhirBenefitSlug } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { safeLazy } from '@/common/utils/import';
import { useLocalSearchParams } from 'expo-router';

const { FringeActivityPage, ItalyBenefitPage } = safeLazy(
  () => import('@/web/containers/Dashboard/ITDashboard/ITDashboard')
);

export default function WelfareBenefitPage() {
  const { company } = useEmployeeDetails();
  const { slug } = useLocalSearchParams<{ slug: IMenhirBenefitSlug }>();

  if (company.settings.plan === PLAN.ITALY_FRINGE && slug === 'fringe') {
    return (
      <RouterSuspense>
        <FringeActivityPage />
      </RouterSuspense>
    );
  }

  return (
    <RouterSuspense>
      <ItalyBenefitPage />
    </RouterSuspense>
  );
}
